import React, { useState, useEffect, useContext } from 'react';
import { Button, Grid } from '@material-ui/core';
import { Notifications, DataTable } from '../../../shared';
import { qualityApi as api } from '../../../api/quality';
import { UserContext } from '../../../contexts/UserContext';

const ViewCCOF = () => {
    const [notification, setNotification] = useState({ text: '', level: '' });
    const [rows, setRows] = useState([]);
    const user = useContext(UserContext);

    const getRows = async () => {
        let res = await api.getCCOF(user.getFacilityID());
        if (res.status) {
            setRows(res.data.rows);
        }
    };

    useEffect(() => {
        getRows();
    }, []);

    const columns = [
        { accessor: 'id', Header: 'Shipment ID' },
        { accessor: 'shopOrderNum', Header: 'Order Number' },
    ];

    return (
        <Grid container>
            <Notifications options={notification} />
            <Grid item md={12} style={{ textAlign: 'left', paddingLeft: '40px' }}>
                <h1>Shipments to use for a CCOF Audit</h1>
            </Grid>
            <Grid item xs={12}>
                <DataTable data={rows} columns={columns} />
            </Grid>
        </Grid>
    );
};

export { ViewCCOF };
